import React, { useContext } from "react";
import { Routes, Route, Navigate } from 'react-router-dom';
import { authRoutes, publicRoutes } from "../routes";
import { LOGIN_ROUTE } from "../utils/const";
import { Context } from "../index";
import Auth from "../pages/Auth";

const AppRouter = ({ barLineHeight }) => {
    const {user} = useContext(Context)

    return (
        <Routes>
            <Route path="/login" element={<Auth barLineHeight={barLineHeight} />} />
            {user.token && authRoutes.map(({ path, Component }) =>
                <Route key={path} path={path} Component={Component} exact/>
            )}
            {publicRoutes.map(({ path, Component }) =>
                <Route key={path} path={path} Component={Component} exact/>
            )}
            <Route path="*" element={<Navigate to={LOGIN_ROUTE} />}/>
        </Routes>
    );
    
};

export default AppRouter;
